import { render, staticRenderFns } from "./HeaderComponet.vue?vue&type=template&id=05fe6a96&scoped=true&"
import script from "./HeaderComponet.vue?vue&type=script&lang=js&"
export * from "./HeaderComponet.vue?vue&type=script&lang=js&"
import style0 from "./HeaderComponet.vue?vue&type=style&index=0&id=05fe6a96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fe6a96",
  null
  
)

export default component.exports